import { useRequest } from "@prismicio/editor-support/Suspense"

import { getAllReleases, getReleaseId } from "../../../app/services/release"
import { DocumentVersions } from "./DocumentVersions"
import { useVersionPanel } from "./useVersionPanel"
import {
  getReleaseDisplayInfos,
  getVersionDisplayInfo
} from "./VersionPanel.utils"

export function VersionPanel() {
  const {
    local,
    selectReleaseVersion,
    selectVersion,
    localVersionSelection,
    localReleaseSelection,
    versions
  } = useVersionPanel()

  const repositoryReleases = useRequest(getAllReleases, [true])

  const documentReleaseVersions = versions.filter(
    (version) => version.status === "release"
  )

  const unclassified = getVersionDisplayInfo(versions, "unclassified")
  const published = getVersionDisplayInfo(versions, "published")
  const { plannedReleases, migrationReleases } = getReleaseDisplayInfos(
    repositoryReleases,
    documentReleaseVersions
  )

  return (
    <DocumentVersions
      local={local}
      unclassified={
        unclassified && {
          ...unclassified,
          id: "unclassified",
          header: "Edited",
          selected: localVersionSelection === unclassified.version.version_id,
          onSelect: () => selectVersion(unclassified.version)
        }
      }
      published={
        published && {
          ...published,
          id: "published",
          header: "Published",
          selected: localVersionSelection === published.version.version_id,
          onSelect: () => selectVersion(published.version)
        }
      }
      release={
        plannedReleases.length !== 0
          ? {
              id: "release",
              header: "Planned",
              items: plannedReleases.map((release) => {
                return {
                  title: release.title,
                  subtitle: release.subtitle,
                  selected:
                    localReleaseSelection === getReleaseId(release.version),
                  onSelect: () => selectReleaseVersion(release.version),
                  date: release.date
                }
              })
            }
          : undefined
      }
      migrationRelease={
        migrationReleases.length !== 0
          ? {
              id: "migrationRelease",
              header: "Migration Release",
              items: migrationReleases.map((release) => {
                return {
                  subtitle: release.subtitle,
                  selected:
                    localReleaseSelection === getReleaseId(release.version),
                  onSelect: () => selectReleaseVersion(release.version),
                  date: release.date
                }
              })
            }
          : undefined
      }
    />
  )
}
